import moment from "moment";
import { format, getDay, isValid as isValidDate } from "date-fns";

const locales = require('moment/min/locales.min');

let locale = (navigator.language || navigator.browserLanguage).toLowerCase();

if (locale.indexOf('-') !== -1) {
  const parts = locale.split('-');
  // remove region specifier if it is the same as the language to match moment's locale naming
  if (parts[0] === parts[1]) {
    locale = parts[0];
  }
  else {
    switch (locale) {
      case 'zh-hant':
        console.log('converting zh-hant to zh-tw');
        locale = 'zh-tw';
        break;
      case 'zh-hans':
        console.log('converting zh-hans to zh-cn');
        locale = 'zh-cn';
        break;
    }
  }
}

if (moment.locales().indexOf(locale) !== -1) {
  console.log('updating locale', locale);

  moment.updateLocale(locale, {});
}

export const DEFAULT_FORMAT = "YYYY-MM-DD";
export const HISTORY_MAX = stringApiToMoment(process.env.DEFAULT_START_DATE_HISTORY);

export function daysDiff(a, b) {
  let utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  let utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
};

export function stringApiToDate(dateString) {
  let dateParts = dateString.split('-');
  return new Date(dateParts[0], dateParts[1]-1 , dateParts[2]); //January is 0!
};

export function stringApiToMoment(dateString) {
  return moment(dateString, DEFAULT_FORMAT);
};

export function dateToApiString(date) {
  if (!moment.isMoment(date)) {
    date = moment(date);
  }
  return date.format(DEFAULT_FORMAT);
};

export function dateToString(date = moment(), separator = '/') {
  return date.format(`MM${separator}DD${separator}YYYY`);
}

export function apiToUserString(date) {
  return dateToString(stringApiToMoment(date));
}

export function daysAgo(days, asString = true) {
  let date = new Date();
  date.setDate(date.getDate() - days);
  return asString ? dateToApiString(date) : date;
};

export function calendarMonth(date = new Date()) {
  date.setDate(1);
  return dateToApiString(date);
};

/**
 * @param {Date} date
 * @return {string}
 */
export function fiscalQuarter(date = new Date()) {
  date.setDate(1);

  switch (date.getMonth()) {
  // feb, mar, apr - 1st
  case 1:
  case 2:
  case 3:
    date.setMonth(1);
    break;
  // may, jun, jul - 2nd
  case 4:
  case 5:
  case 6:
    date.setMonth(4);
    break;
  // aug, sep, oct - 3rd
  case 7:
  case 8:
  case 9:
    date.setMonth(7);
    break;
  // nov, dec, jan - 4th
  case 0:
    date.setFullYear(date.getFullYear() - 1);
  case 10:
  case 11:
    date.setMonth(10);
    break;
  }

  return dateToApiString(date);
}

/**
 * @param {Date} date
 * @return {string}
 */
export function fiscalYear(date = new Date()) {
  if (date.getMonth() === 0) {
    date.setFullYear(date.getFullYear() - 1);
  }

  date.setMonth(1);
  date.setDate(1);

  return dateToApiString(date);
};

/**
 * @param {Date, moment} date
 * @return {?number}
 */
function getRawDayNumber(date) {
  if (moment.isMoment(date)) {
    return date.day();
  } else if (isValidDate(date)) {
    return getDay(date);
  } else {
    console.warn("Invalid date");
    console.error({ date });
    throw new Error(`Cannot get day number from ${date}`);
  }
}

/**
 * @param {Date} date
 * @return {number}
 */
export function getDayNumber(date = new Date()) {
  const num = getRawDayNumber(date);

  return (num + 6) % 7;
};

/**
 * @param {string} dateString
 * @return {string}
 */
export function formatOpportunityCloseDate(dateString) {
  // expected date format: dd-mmm-yy
  if (dateString.length > 9) {
    return dateString.substring(0, 9);
  }

  return dateString;
}



// WEBPACK FOOTER //
// ./app/utils/date.js